AOS.init({
  offset: 200,
  duration: 600,
  easing: 'ease-in-quad',
  delay: 100,
});